import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 新增分组
export function groupAdd(data) {
  return request({
    url: URL.external.chartGroupSetting.groupAdd,
    method: 'post',
    data
  })
}

// 编辑分组
export function groupModify(data) {
  return request({
    url: URL.external.chartGroupSetting.groupModify,
    method: 'put',
    data
  })
}

// 获取分组列表
export function groupList(params) {
  return request({
    url: URL.external.chartGroupSetting.groupList,
    method: 'get',
    params
  })
}

// 删除分组
export function deleteGroup(params) {
  return request({
    url: URL.external.chartGroupSetting.deleteGroup,
    method: 'delete',
    params
  })
}
